import { DEFAULT_QUERY_LIMIT } from '../../config';

export default {
    props: {
        search: {
            type: Object,
            required: false,
            default: () => null,
        },
        requestSearch: {
            type: Object,
            required: false,
            default: () => null,
        },
        hideResults: {
            type: Boolean,
            default: true,
        },
        hasFilters: {
            type: [String, Boolean],
            default: false,
        },
        hasResults: {
            type: [String, Boolean],
            default: false,
        },
        hasQuery: {
            type: [String, Boolean],
            default: false,
        },
        hasLoadedOnce: {
            type: [String, Boolean],
            default: false,
        },
        skip: {
            type: [String, Number],
            default: '',
        },
        limit: {
            type: [String, Number],
            default: DEFAULT_QUERY_LIMIT,
        },
        sortBy: {
            type: String,
            default: '',
        },
        sortDest: {
            type: String,
            default: '',
        },
    },
    computed: {
        searchResponse() {
            return this.requestSearch?.response;
        },
        searchRequestId() {
            return this.requestSearch?.requestId || '';
        },
        isResultsVisible() {
            return this.hideResults === false &&
                (true || this.hasResults) && !this.showCompletions &&
                (this.store.state.ui.isFiltersOpened && this.$screen.isMobile) === false;
        },
        offerTemplates() {
            return this.search && this.search.templates && typeof this.search.templates === 'object'
                ? this.search.templates
                : {};
        },
        isSearchLoading() {
            return this.requestSearch ? this.requestSearch.isLoading : false;
        },
        isSearchError() {
            return this.requestSearch ? this.requestSearch.isError : false;
        },
        errorTextSearch() {
            return this.requestSearch ? this.requestSearch.errorText : null;
        },
        totalItemsCount() {
            return this.searchResponse ? this.searchResponse.hits || 0 : 0;
        },
        filterValues() {
            return this.searchState.public ? this.searchState.public.params || [] : [];
        },
        filterItems() {
            let clonedSearchResponse = JSON.parse(JSON.stringify(this.searchResponse));
            if (clonedSearchResponse && this.$configuration.sortFilters.length) {
                let sortFilters = this.$configuration.sortFilters;
                let objects = clonedSearchResponse.params;
                objects.sort((a, b) => {
                    const indexA = sortFilters.indexOf(a.name);
                    const indexB = sortFilters.indexOf(b.name);

                    if (indexA === -1 && indexB === -1) {
                        return 0;
                    } else if (indexA === -1) {
                        return 1;
                    } else if (indexB === -1) {
                        return -1;
                    } else {
                        return indexA - indexB;
                    }
                });
            }
            return clonedSearchResponse ? clonedSearchResponse.params || [] : [];
        },
        isFiltersBlockVisible() {
            return !this.hideResults &&
                this.filterItems.length > 0 &&
                (!this.$screen.isMobile || (this.$screen.isMobile && !this.store.state.ui.isCategoriesListVisible));
        },
        hasCachedResults() {
            return this.search && this.search.offers && this.search.offers.length;
        },
        currencyInOffers() {
            return this.search && this.search.offers ? (this.search.offers[0] || {}).currency : '';
        },
        selectedCategoryId() {
            return this.searchState.public.categoryId ? this.searchState.public.categoryId : '';
        },
        resultsCategoryId() {
            const selectedCategoryId = this.searchState.public.categoryId || this.selectedCategoryId;

            const selectedCategoryFilter = (this.searchState.public.params || []).find(
                filter => filter.field === 'category');

            if ((selectedCategoryFilter || {}).options && selectedCategoryFilter.options.length >= 1) {
                return selectedCategoryFilter.options;
            } else {
                return selectedCategoryId;
            }
        },
    },
    methods: {
        toggleFilters(value) {
            const resultValue = value === undefined ? !this.store.state.ui.isFiltersOpened : !!value;
            if (resultValue) {
                this.store.commit('ui/SET_PROPERTY', { key: 'isCategoriesListVisible', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isImageSearchVisible', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isCompletionsVisible', value: false });
            }
            this.store.commit('ui/SET_PROPERTY', { key: 'isFiltersOpened', value: resultValue });
        },
        emitNavigateCategoryFilterParam(params) {
            const categoryId = params.categoryId;
            if (categoryId) {
                this.$emit('filters-select', {
                    changed: ['category'],
                    filters: [
                        {
                            condition: 'in',
                            field: 'category',
                            options: [String(categoryId)],
                        },
                    ],
                });
            } else {
                this.$emit('filters-change', {
                    changed: ['category'],
                    filters: [],
                });
            }
        },
        handleNavigateCategory(params) {
            this.emitNavigateCategoryFilterParam(params);
        },
        handleScrollToTop() {
            this.$refs['search-results'].$el.scrollIntoView({
                block: 'start',
                behavior: 'smooth',
            });
        },
        emitNavigateCategory(params) {
            this.$emit('navigate-category', {
                ...this.searchState.public,
                ...params,
                query: '',
            });
        },
    },
};
